import Segment from '../../shared/segment';
import QuestionTitle from './question-title';
import { QuestionType } from '../../../api/student-question';
import { useBooleanState } from '../../../hooks/index/use-boolean-state';
import Button from '../../shared/buttons/button';
import QuestionOptions from './question-options';

export type StudentQuestionPropsType = {
  questionNumber: number;
  questionCount: number;
  question: QuestionType;
  selectedOptionId: number | null;
  studentQuestionStatus: -1 | 0 | 1;
};

function StudentQuestion({
  questionNumber,
  questionCount,
  question,
  selectedOptionId,
  studentQuestionStatus
}: StudentQuestionPropsType) {
  const { value: showAnswer, setTrue: setShowAnswer } = useBooleanState(false);

  const color = !showAnswer ? 'white' : ['red', 'yellow', 'green'][studentQuestionStatus + 1];

  return (
    <div>
      <Segment noMargin color={color}>
        <QuestionTitle questionNumber={questionNumber} questionCount={questionCount} />
        <div className='mx-3 flex flex-col gap-2 py-3'>
          <div dangerouslySetInnerHTML={{ __html: question.question }} className='ck-content' />
          <div className='my-2'>
            <QuestionOptions
              options={question.options}
              selectedOptionId={selectedOptionId}
              showAnswer={showAnswer}
            />
          </div>
        </div>

        {showAnswer ? (
          <div className='flex flex-col gap-2'>
            <p className='text-lg font-medium'>جواب:</p>
            <div
              dangerouslySetInnerHTML={{ __html: question.answer }}
              className='ck-content mx-3'
            />
          </div>
        ) : (
          <div className='my-3'>
            <Button content='دیدن جواب' onClick={setShowAnswer} className='mx-auto w-2/3' />
          </div>
        )}
      </Segment>
    </div>
  );
}

export default StudentQuestion;
